import request from '../utils/request';

// 分页查询支付订单
export const listPaymentOrders = (params) => {
  return request({
    url: '/payment-order/list',
    method: 'post',
    data: params
  });
};

// 查询指定用户的支付订单
export const listUserPaymentOrders = (userId, page = 1, pageSize = 10) => {
  return request({
    url: `/payment-order/user/${userId}`,
    method: 'get',
    params: { page, pageSize }
  });
};
